export default [
  // 左侧菜单收缩展开
  {
    name: 'SIDER_COLLAPSED',
    value: 'sider_collapsed'
  },
]